module.exports = __webpack_public_path__ + "img/2020_DSC_00051.d3e0d740.jpg";